import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { Toast, ToastContainer } from 'react-bootstrap';

const ToastContext = createContext({
  showToast: () => {},
});

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const showToast = useCallback((message, variant = 'info', delay = 3500) => {
    if (!message) return;
    const id = `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
    setToasts((prev) => [...prev, { id, message: String(message), variant, delay }]);
  }, []);

  const removeToast = useCallback((id) => {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  }, []);

  const value = useMemo(() => ({ showToast }), [showToast]);

  useEffect(() => {
    const onToast = (event) => {
      const detail = event?.detail || {};
      if (!detail?.message) return;
      showToast(detail.message, detail.variant || 'info', detail.delay || 3500);
    };
    window.addEventListener('app:toast', onToast);
    return () => window.removeEventListener('app:toast', onToast);
  }, [showToast]);

  return (
    <ToastContext.Provider value={value}>
      {children}
      <ToastContainer
        position="top-end"
        className="p-3"
        style={{ zIndex: 99999, position: 'fixed', top: 0, right: 0, pointerEvents: 'none' }}
      >
        {toasts.map((t) => (
          <Toast
            key={t.id}
            bg={t.variant === 'warning' ? 'light' : t.variant}
            autohide
            delay={t.delay}
            onClose={() => removeToast(t.id)}
            style={{ pointerEvents: 'auto', minWidth: 280 }}
            className="border-0 shadow-sm"
          >
            <Toast.Body className={t.variant === 'warning' ? 'text-dark' : 'text-white'}>
              {t.message}
            </Toast.Body>
          </Toast>
        ))}
      </ToastContainer>
    </ToastContext.Provider>
  );
}

export function useToast() {
  return useContext(ToastContext);
}
